import Vue from "vue";
import App from "./App.vue";
import router from "./router";
// import 'ant-design-vue/dist/antd.css'
import "./index.scss"; //出于有sb一开始搭建就用的node_modules  antd里的css修改的 我只好copy过来了 上面注释了
import store from "./store/store";
import Interface from "./utils/interface.js";
import axios from "./utils/axiosTool";
import "./assets/public.css";
import modalreset from "./commom/modalreset.js";
import antdconfig from "./commom/module/index.js";
import {
  Button,
  Menu,
  Icon,
  Table,
  Divider,
  Modal,
  Row,
  Col,
  Input,
  Layout,
  Select,
  Pagination,
  Radio,
  Popconfirm,
  //Message,
  Upload,
  Tree,
  Switch,
  Drawer,
  Empty,
  TreeSelect,
  Dropdown,
  Spin,
  Result,
  DatePicker,
} from "ant-design-vue";

Vue.config.productionTip = false;
Vue.prototype.$axios = axios;
Vue.prototype.$interface = Interface; //接口
Vue.use(antdconfig);
Vue.use(modalreset);
Vue.use(Button);
Vue.use(Menu);
Vue.use(Icon);
Vue.use(Table);
Vue.use(Divider);
Vue.use(Modal);
Vue.use(Row);
Vue.use(Col);
Vue.use(Input);
Vue.use(Layout);
Vue.use(Select);
Vue.use(Pagination);
Vue.use(Interface);
Vue.use(Radio);
Vue.use(Popconfirm);
Vue.use(Modal);
//Vue.use(Message)
Vue.use(Upload);
Vue.use(Tree);
Vue.use(Switch);
Vue.use(Drawer);
Vue.use(Empty);
Vue.use(TreeSelect);
Vue.use(Dropdown);
Vue.use(Spin);
Vue.use(Result);
Vue.use(DatePicker);
Vue.prototype.$modalreset = modalreset;

new Vue({
  router,
  axios,
  store,
  render: (h) => h(App),
}).$mount("#app");
